'use strict';

class Sharing {

	constructor(aElement) {

		this.attachFacebookSharing();
		this.attachLinkedInSharing();
		this.attachTwitterSharing();

	}

	attachFacebookSharing() {

		let button = $('.-facebook-sharing');

		button.on('click', (event) => {
			let href = button.data('origin');
			let appID = button.data('app-id');
			FB.ui(
				{
					app_id: appID,
					method: "share",
					display: "popup",
					href: href
				},
				(response) => {
				}
			);
		});

	}

	attachLinkedInSharing() {

		let button = $('.-linkedin-sharing');

		button.on('click', (event) => {
			let target = button.data('target');
			open(target, 'Popup', 'scrollbars=1,resizable=1,height=442,width=550');
			return false;
		});

	}

	attachTwitterSharing() {

		let button = $('.-twitter-sharing');

		button.on('click', (event) => {
			let target = button.data('target');
			open(target, 'Popup', 'scrollbars=1,resizable=1,height=252,width=550');
			return false;
		});

	}

}

module.exports = Sharing;